import React from "react";
import { Link } from "react-router-dom";

// Variants: primary (ink bg), secondary (transparent + ink border),
// mint, yellow, coral (playful solid fills). Sizes: md, lg, sm.
const base =
  "inline-flex items-center justify-center gap-2 font-semibold rounded-pill transition-transform transition-colors duration-200 active:translate-y-[1px] disabled:opacity-50 disabled:cursor-not-allowed select-none";

const variants = {
  primary: "bg-ink text-warm border-2 border-ink hover:bg-[#2c2363]",
  secondary: "bg-transparent text-ink border-2 border-ink hover:bg-ink hover:text-warm",
  mint: "bg-mint text-ink border-2 border-ink hover:brightness-95",
  yellow: "bg-yellow text-ink border-2 border-ink hover:brightness-95",
  coral: "bg-coral text-ink border-2 border-ink hover:brightness-95",
  ghost: "bg-transparent text-ink border-2 border-transparent hover:bg-cream-2",
};

const sizes = {
  sm: "text-sm px-4 py-2",
  md: "text-base px-5 py-3",
  lg: "text-lg px-7 py-4",
};

export default function Button({
  as = "button",
  to,
  href,
  variant = "primary",
  size = "md",
  className = "",
  children,
  ...props
}) {
  const cls = `${base} ${variants[variant] || variants.primary} ${sizes[size] || sizes.md} ${className}`;

  if (to) {
    return (
      <Link to={to} className={cls} {...props}>
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} className={cls} {...props}>
        {children}
      </a>
    );
  }
  return (
    <button className={cls} {...props}>
      {children}
    </button>
  );
}
